import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={21.044}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27722 22699"
    {...props}
  >
    <path
      d="M23396 3412v-654h4326V0H0v2758h4326v654h813v12669c-1648 384-2883 2964-2883 6189v429h6621v-429c0-3225-1236-5805-2881-6189V3412h813v-654h5810v654h813v12669c-1648 384-2883 2964-2883 6189v429h6621v-429c0-3225-1236-5805-2881-6189V3412h813v-654h5810v654h812v12669c-1647 384-2882 2964-2882 6189v429h6623v-429c0-3225-1235-5805-2883-6189V3412h814z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
